import { Injectable, Injector } from '@angular/core';
import { ResourceReaderService } from './resource-reader.service';
import { HttpInterceptor } from './http-interceptor.service';
import { AuthService } from '../auth/auth.service';
import { DatabaseService } from '../storage/database.service';
import { EventsManagerService } from './events-manager.service';
import { AppConfigurationService } from './app-configuration.service';

const FEATURED_VERSIONS = 'featured_versions';
@Injectable()
export class FeaturedVersionsService extends ResourceReaderService {

    constructor(
        http: HttpInterceptor,
        authService: AuthService,
        databaseService: DatabaseService,
        eventsService: EventsManagerService,
        AppConfiguration: AppConfigurationService,
        injector: Injector
    ) {
        super(
            'resources',
            http,
            authService,
            databaseService,
            eventsService,
            AppConfiguration,
            injector,
            FEATURED_VERSIONS,
            'Featured Versions'
        );
    }

    public loadResources() {
        this.loadLocalVersion().subscribe((localVersionResponse) => {
            const date = new Date();
            const cacheString =
                '' + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes();
            this.get('featured-versions', { v: cacheString }).subscribe(
                (response) => {
                    this.storeLocalVersion(response);
                },
                (error) => {
                    this._loaded = true;
                    this._onLoaded.next(true);
                    console.log(
                        'Error loading featured versions file, using local version (' +
                        this.version +
                        ')'
                    );
                }
            );
        });
    }
}
